let slotSeq = 0;

/** Стабильный ключ слота этапа для v-for и drag-and-drop. */
export function createAdaptiveRtSlotId() {
  slotSeq += 1;
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `stage-slot-${Date.now()}-${slotSeq}`;
}
